import { render } from "./updateGallery.vue?vue&type=template&id=0530e056&scoped=true"
import script from "./updateGallery.vue?vue&type=script&lang=js"
export * from "./updateGallery.vue?vue&type=script&lang=js"

import "./updateGallery.vue?vue&type=style&index=0&id=0530e056&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0530e056"]])

export default __exports__